/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import {
  Card,
  Grid,
  TextField
} from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import WarningModal from "components/displayModel/warningModel";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { getDeliveryTimeById, saveDeliveryTime, updateDeliveryTimeByID } from "utils/api";
import { getScreenRight, showResMsg } from "utils/generic";
import { genericMessage } from "utils/genericMessages";

const errMsg = {
  color: `red`,
  fontSize: `11px`,
};


let fetchDeliveryTime;

let LOGIN_DETAILS;

function AddNewDeliveryTime() {
  const { id } = useParams();

  const [screenName, setScreenName] = useState("Add New Delivery Time");
  const [fromDistanceErr, setFromDistanceErr] = useState(false);
  const [toDistanceErr, setToDistanceErr] = useState(false);
  const [deliveryTimeErr, setDeliveryTimeErr] = useState(false);
  const [controller] = useMaterialUIController();
  const [confirmDialogeFlag, setConfirmDialogeFlag] = useState(false);
  const [errDeliverTime, setErrDeliverTime] = useState("");
  const { sidenavColor } = controller;
  const [disableColor, setDisableColor] = useState(false);
  const navigate = useNavigate();
  const dispatch =useDispatch()


  const [values, setValues] = React.useState({
    toDistance: "",
    fromDistance: "",
    deliveryTime: "",
    // searchParameter: "",
    // searchParameterList: [
    //   "toDistance",
    //   "fromDistance",
    //   "deliveryTime",
    // ],
  });

  let mandateFlag = false;
  LOGIN_DETAILS = JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'));
  values.businessUserID = LOGIN_DETAILS.businessUserID;
  const fromDistance = parseInt(values.fromDistance);
  const toDistance = parseInt(values.toDistance);

  useEffect(() => {
    if (id !== undefined) {
      setScreenName("Edit Delivery Time")
      values._id = id;
      getDeliveryTimeById(values, (data)=>{
        if (data.Result_Output.length > 0) {
          let selectedIDData;
          for (let delivery of data.Result_Output) {
            if (delivery._id === id) {
              selectedIDData = delivery
            }
          }
          fetchDeliveryTime = data.Result_Output;
          setValues(selectedIDData)
        }
      },dispatch)
     
    }
    getRight()
  }, []);
  async function getRight() {
    let right = await getScreenRight("Delivery Time")
    if (right === "Full Access") {
        setDisableColor(false)
    }
    else setDisableColor(true)

}

  // const handleChange = (name) => (event) => {
  //   setValues({ ...values, [name]: event.target.value });
  // };

  const handleChange = (name) => (event) => {
    if (event.target.validity.valid) {
      setValues({ ...values, [name]: event.target.value });
    }
  };


  const addDelivery = () => {
let DeliveryError = false
    mandateFlag = false;
    if (values.fromDistance.toString().trim() === "") {
      setFromDistanceErr("From Distance can't be blank");
      mandateFlag = true;
    }
    else if (isNaN(fromDistance)) {
      setFromDistanceErr("From Distance must be numbers")
      mandateFlag = true;
    }
    else setFromDistanceErr(false);
    if (values.toDistance.toString().trim() === "") {
      setToDistanceErr("To Distance can't be blank ");
      mandateFlag = true;
    }
    else if (values.fromDistance === values.toDistance) {
      setToDistanceErr("To Distance can't be same as From Distance");
      mandateFlag = true;
    }
    else if (isNaN(toDistance)) {
      setToDistanceErr("To Distance must be numbers");
      mandateFlag = true;
    } else if (toDistance < fromDistance) {
      setToDistanceErr("To Distance must be greater than From Distance");
      mandateFlag = true;
    } else {
      setToDistanceErr(false);
    }
    if (values.deliveryTime.toString().trim() === "") {
      setDeliveryTimeErr(true);
      mandateFlag = true;
    } else setDeliveryTimeErr(false);
    if (mandateFlag) {
      return;
    }
    if (id === undefined) {
      saveDeliveryTime(values , (data)=>{
        showResMsg(data.Result_Status? genericMessage.added : data.Result_Message, 1000, data.Result_Status, navigate, '/deliveryTime');
      },dispatch)
      
    }

    else {
      for (let i = 0; i < fetchDeliveryTime.length; i++) {

        if (fetchDeliveryTime[i]._id === id) {
          if (fetchDeliveryTime[i].fromDistance !== 0) {
             if  (fetchDeliveryTime[i - 1].toDistance+1 !== parseInt(values.fromDistance)){
              DeliveryError = true
              setErrDeliverTime("From Distance")
            }
            else if  (fetchDeliveryTime[i - 1].toDistance > parseInt(values.fromDistance)) {
              DeliveryError = true
              setErrDeliverTime("From Distance")
            }
            
            if(fetchDeliveryTime[i + 1] ){
               if (fetchDeliveryTime[i + 1].fromDistance < parseInt(values.toDistance)) {
                setErrDeliverTime("To Distance")
                DeliveryError = true
              }else if( fetchDeliveryTime[i + 1].fromDistance-1  !==  parseInt(values.toDistance)){

                setErrDeliverTime("To Distance")
                DeliveryError = true
            }
            }
           
          } else {
            if(fetchDeliveryTime[i + 1]  ){
              if (fetchDeliveryTime[i + 1].fromDistance < parseInt(values.toDistance)) {
               setErrDeliverTime("To Distance")
               DeliveryError = true
             }
             else if( fetchDeliveryTime[i + 1].fromDistance-1  !==  parseInt(values.toDistance)){

              setErrDeliverTime("To Distance")
              DeliveryError = true
          }
           }
          }
        }
      }
      if(!DeliveryError){

        updateDeliveryTime()
      }else{

        setConfirmDialogeFlag(true)
      }


    }
  };


  const handleCancel = name => event => {
    setConfirmDialogeFlag(false);
  };

  const handleChangeValue = async (id) => {
    updateDeliveryTime();
    setConfirmDialogeFlag(!confirmDialogeFlag);
  };

  const updateDeliveryTime = async () => {
    updateDeliveryTimeByID(values , (data)=>{
      showResMsg(data.Result_Status? genericMessage.updated : data.Result_Message, 1000, data.Result_Status, navigate, '/deliveryTime');
    },dispatch)
   
  };


  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={6} mb={3}>
        <Grid container spacing={2} sx={{ display: "flex", justifyContent: "center" }}>
          <Grid item xs={10} spacing={6} >
            <Card sx={{ boxShadow: "none" }}>
              <MDBox
                mx={2}
                mt={-3}
                mb={1.5}
                py={2}
                px={2}
                variant="gradient"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  {screenName}
                </MDTypography>
              </MDBox>
              <MDBox pt={4} pb={3} px={3}>
                <Grid container columnSpacing={5}>
                  <Grid item xs={12} lg={4}>
                    <MDBox component="form" role="form">
                      <MDBox mb={4} xs={12}>
                        <TextField
                          type="text"
                          label="From Distance (Km)"
                          variant="outlined"
                          fullWidth
                          inputProps={{
                            pattern: "^[0-9]+$",
                            maxLength: 5
                          }}
                          disabled={(parseInt(values.fromDistance) === 0 && typeof id != 'undefined') ? true : false}
                          onChange={handleChange("fromDistance")}
                          value={values.fromDistance}
                        />
                        {fromDistanceErr !== "" ? <span style={errMsg}>{fromDistanceErr}</span> : ""}
                        {/* {fromDistanceErr ? <span style={errMsg}>From Distance can't be blank</span> : ""} */}
                      </MDBox>
                    </MDBox>
                  </Grid>

                  <Grid item xs={12} lg={4}>
                    <MDBox component="form" role="form">
                      <MDBox mb={4} xs={12}>
                        <TextField
                          type="text"
                          label="To Distance (Km)"
                          variant="outlined"
                          fullWidth
                          inputProps={{
                            pattern: "^[0-9]+$",
                            maxLength: 5
                          }}
                          onChange={handleChange("toDistance")}
                          value={values.toDistance}
                        />
                        {toDistanceErr !== "" ? <span style={errMsg}>{toDistanceErr}</span> : ""}
                      </MDBox>
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <MDBox component="form" role="form">
                      <MDBox mb={4} xs={12}>
                        <TextField
                          type="text"
                          label="Delivery Time "
                          variant="outlined"
                          fullWidth
                          inputProps={{
                            pattern: "^[A-Za-z0-9 ]+$",
                            maxLength: 30
                          }}
                          onChange={handleChange("deliveryTime")}
                          value={values.deliveryTime}
                        />
                        {deliveryTimeErr ? <span style={errMsg}>Delivery Time can't be blank</span> : ""}
                      </MDBox>
                    </MDBox>
                  </Grid>
                </Grid>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
        <Grid
          container
          mt={2}
          columnSpacing={4}
          alignItems="center"
          display="flex"
          justifyContent="center"
        >
          <Grid item xs={12} md={4} spacing={2} lg={1.2}>

            <Link to={"/deliveryTime"}>
              <MDButton
                className="btn-block center-container-btn btn-warning btn-back rightSpace"
                color="warning"
                fullWidth
              >
                Cancel
              </MDButton>
            </Link>
          </Grid>
          <Grid item xs={12} md={4} spacing={2} lg={1.2}>
            <MDButton
              onClick={addDelivery}
              rel="noreferrer"
              variant="gradient"
              color="success"
              fullWidth
            >
              {id !== undefined ? <>Update</>:<>Save</>}
             
            </MDButton>
          </Grid>

        </Grid>
      </MDBox>
      <WarningModal
        open={confirmDialogeFlag}
        errorMesssage={errDeliverTime}
        handleDelete={handleChangeValue}
        handleCancel={handleCancel("handleCancel")}
        closeModalClick={handleCancel("closeModalClick")}
      />
    </DashboardLayout>
  );
}

export default AddNewDeliveryTime;
